import * as mathHelpers from '../../utilities/math-helpers';

export const dxfHelpers = {
  rotateVector(origin, angle) {
    if (!angle) {
      return origin;
    }
    const x2 = Math.cos(angle) * origin.x - Math.sin(angle) * origin.y;
    const y2 = Math.sin(angle) * origin.x + Math.cos(angle) * origin.y;
    return { x: x2, y: y2 };
  },

  transformInsertVertex(insert, vertex) {
    let scaledVector = { x: vertex.x, y: vertex.y, z: vertex.z };

    scaledVector.x *= insert.xScale ? insert.xScale : 1;
    scaledVector.y *= insert.yScale ? insert.yScale : 1;
    scaledVector.z *= insert.zScale ? insert.zScale : 1;

    let rotatedElemPostion = this.rotateVector(
      scaledVector,
      mathHelpers.degreesToRadians(insert.rotation),
    );

    let newVertex = {
      x: rotatedElemPostion.x + insert.position.x,
      y: rotatedElemPostion.y + insert.position.y,
    };

    if (!isNaN(scaledVector.z)) {
      newVertex.z = scaledVector.z + insert.position.z;
    } else if (!isNaN(insert.position.z)) {
      newVertex.z = insert.position.z;
    }

    if (vertex.bulge) {
      newVertex.bulge = vertex.bulge;
    }

    return newVertex;
  },

  transformInsertPolygon(insert, polygon) {
    polygon[0] = this.transformInsertVertex(insert, polygon[0]);
    polygon[1] = this.transformInsertVertex(insert, polygon[1]);
    polygon[2] = this.transformInsertVertex(insert, polygon[2]);
  },

  transformInsertVertices(insert, vertices) {
    var newArray = [];

    for (let i = 0; i < vertices.length; i++) {
      let vertex = {
        x: vertices[i].x,
        y: vertices[i].y,
      };

      if (!isNaN(vertices[i].z)) {
        vertex.z = vertices[i].z;
      }

      let newVertex = this.transformInsertVertex(insert, vertex);

      if (vertices[i].bulge) {
        newVertex.bulge = vertices[i].bulge;
      }

      newArray.push(newVertex);
    }
    return newArray;
  },

  transformInsertScale(insert, innerInsert) {
    if (insert.xScale) {
      innerInsert.position.x *= insert.xScale;

      if (innerInsert.xScale) {
        innerInsert.xScale *= insert.xScale;
      } else {
        innerInsert.xScale = insert.xScale;
      }
    }

    if (insert.yScale) {
      innerInsert.position.y *= insert.yScale;

      if (innerInsert.yScale) {
        innerInsert.yScale *= insert.yScale;
      } else {
        innerInsert.yScale = insert.yScale;
      }
    }

    if (insert.zScale) {
      innerInsert.position.z *= insert.zScale;

      if (innerInsert.zScale) {
        innerInsert.zScale *= insert.zScale;
      } else {
        innerInsert.zScale = insert.zScale;
      }
    }
  },
};
